import { useCallback } from 'react';

import {
  InteractiveResponseCategoriseProperties,
  SettingProps,
} from '../interactive-response-categorise.constants';
import { getItemPayload } from '../../sequence/settings/interactive-response-settings.utils';
import { DraftAction } from 'global/constants';
import { useBatchComponentUpdateContext } from 'approot/activity-builder/components/shared/batch-component-update.context';

export const useInteractiveResponseCategoriseUpdate = ({
  id,
  sectionId,
}: SettingProps) => {
  const { loading, updateComponentProperties } =
    useBatchComponentUpdateContext();

  const handleUpdate = useCallback(
    (
      newProperties: InteractiveResponseCategoriseProperties,
      options?: {
        draftAction?: DraftAction;
        isSaveImmediate?: boolean;
        onCompleted?: () => void;
      }
    ) => {
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          addDraftAction: options?.draftAction,
          componentData: {
            properties: {
              interactiveResponseCategorise: {
                ...newProperties.interactiveResponseCategorise,
                items: getItemPayload(
                  newProperties.interactiveResponseCategorise.items
                ),
              },
              dimensionData: newProperties.categoriseDimensionData || null,
            },
          },
        },
        properties: newProperties,
        typename: 'ActivitiesCategoriseResponseComponent',
        isSaveImmediate: options?.isSaveImmediate,
        onCompleted: options?.onCompleted,
      });
    },
    [id, sectionId, updateComponentProperties]
  );

  return {
    loading,
    handleUpdate,
  };
};
